module.exports = __webpack_public_path__ + "img/net.d0289dc0.png";